import { Component } from '@angular/core';
import { MainPage, NavController, ToastController, ErrorResult, LocalStorageService, AlertController, App, UserService } from '../mainpage';
import { ContestService } from '../../providers/contest';
import { GameGroup } from '../../entities/gamegroup';
import { Rank } from '../../entities/rank';
import { StatmentPage } from '../contest/statment';

/*
declare function Teste();
declare var fingerprint;
declare function encryptData(data): any;
declare function decrypt(data): any;
*/

@Component({
  selector: 'page-rank',
  templateUrl: 'rank.html'
})

export class  RankPage extends MainPage {
    public gameGroups: GameGroup[];
    public selectedGroup: GameGroup;
    public rankInfo: Rank[];
    constructor(public appCtrl: App, public navCtrl: NavController, protected toastCtrl: ToastController, 
        public localStorageService: LocalStorageService, public contestService: ContestService, 
        protected alertController: AlertController,
        protected userService: UserService) {
        super(navCtrl, toastCtrl, localStorageService, alertController, userService, appCtrl);
        this.loadPage();
    }

    public loadPage(): void {
        this.contestService.getGroups().then((data: GameGroup[]) => {
            this.groupsLoaded(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    public groupsLoaded(gameGroup: GameGroup[]): void {
        this.gameGroups = gameGroup;
        for(var i=0; i<this.gameGroups.length; i++) {
            if (this.gameGroups[i].IsDefault) {
                this.selectedGroup = this.gameGroups[i];
                break;
            }
        }
        this.loadRank();
    }

    statment(myTicket: string): void {
        this.appCtrl.getRootNav().push(StatmentPage, {ticket: myTicket, groupId: this.selectedGroup.GameGroupId});
    }

    loadRank(): void {
        this.contestService.getRank(this.selectedGroup.GameGroupId).then((data: Rank[]) => {
            this.rankLoaded(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    rankLoaded(groupRank: Rank[]): void {
        this.rankInfo = groupRank;
    }

    changeGroup(): void {
        this.loadRank();
    }

    public compareGroup(g1: GameGroup, g2:GameGroup): boolean {
        return g1.Fullname === g2.Fullname;
    }
}


// WEBPACK FOOTER //
// ./src/pages/contest/rank.ts